<template>
  <draggable :id="item.id" v-show="!isDeleted">
    <div
      :class="{
        'bg-grey': active === true,
        'text-dark': active === true,
      }"
      class="hover:shadow border bg-white m-1 p-4 rounded-sm border-gray-800 bg-gray-600 border-l-4 flex">
      <vs-icon
        @click="isOpen = !isOpen"
        icon="chevron_right"
        class="mr-4 mt-1 text-dark bg-grey-light p-1 rounded cursor-pointer"
        :class="{
          'text-grey': item.children.length === 0,
          'cursor-pointer': item.children.length < 0
        }"
      />

      <vs-icon
        :icon="item.icon"
        class="mr-4 mt-1" />

      <a @click.prevent="$emit('onClickItemMenu', item)" class="cursor-pointer flex-1">
        {{item.text}}
        <small v-if="item.children.length > 0">({{item.children.length}})</small>
      </a>

      <vs-icon
        class="text-dark bg-grey-light p-1 rounded hover:bg-danger cursor-pointer hover:text-white"
        @click="removeItem"
        icon="delete"></vs-icon>
    </div>

    <div
      class="custom-collapse bg-grey-light pl-3 m-2 pb-2 pt-2"
      v-if="isOpen && item.children.length > 0"
    >
      <container @drop="onDrop">
        <menu-item-list-item
          @onClickItemMenu="$emit('onClickItemMenu', subitem)"
          :item="subitem"
          :menu-id="`s-${menuId}`"
          v-for="subitem in item.children"></menu-item-list-item>
      </container>
    </div>
  </draggable>
</template>

<script>
import { Draggable } from "vue-smooth-dnd";
import { Container } from "vue-smooth-dnd";
import MenuItemForm from "@views/admin/backoffice-nav-management/MenuItemForm.vue";
import {NavigationService} from "@/models/Menu/NavigationService";

export default {
  name: "MenuItemListItem",
  props: ['item', 'menuId', 'active'],
  components: {MenuItemForm, Container, Draggable},
  data:() => ({
    showDialog: false,
    isOpen: false,
    isDeleted: false,
    drag: {
      state: {
        dragging: false,
        isOver: false
      }
    }
  }),
  methods: {
    addChild() {
      this.showDialog = true;
    },
    async removeItem() {
      if (confirm(`Está seguro de eliminar el elemento '${this.item.text}'`)) {
        this.$vs.loading();

        try {
          await NavigationService.removeItem(this.item.id);
          this.isDeleted = true;
          this.successNotif('¡Listo!', 'El elemento del menú se elimino correctamente')
        } catch (e) {
          this.errorNotif('Algo salió mal', 'Hubo un error al eliminar el elemento del menú');
          this.$vs.loading.close();
        } finally {
          this.$vs.loading.close();
        }
      }
    },
    onDrop(dropResult) {
      this.item.children = this.applyDrag(this.item.children, dropResult);
      this.saveSortingItems();
    },
    applyDrag(arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult
      if (removedIndex === null && addedIndex === null) return arr

      const result = [...arr]
      let itemToAdd = payload

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0]
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd)
      }

      return result
    },
    async saveSortingItems() {
      this.item.children.forEach((item, index) =>  {
        item.order = index + 1;
      })

      this.$vs.loading();

      try {
        await NavigationService.changeSort(
            this.menuId,
            this.item.children.map((item) => {
              return {
                menuItemId: item.id,
                order: item.order
              }
            })
        );
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>

<style scoped>

</style>
